import React from 'react';

import { App } from '../../app/AppSingleton';
import DropdownMenu from '../elements/DropdownMenu/DropdownMenu';
import './SettingsMenu.css';
import { DataManagementDialog } from "./DataManagementDialog";
import {MenuItemSpec} from "../elements/DropdownMenu/MenuItemSpec";

interface SettingsMenuProps {
	// Пропсы компонента, если они есть
}

interface SettingsMenuState {
	// Состояние компонента, если нужно
}

class SettingsMenu extends React.Component<
	SettingsMenuProps,
	SettingsMenuState
> {
	private classBlock = 'settings-menu';
	private app: App;

	constructor(props: SettingsMenuProps) {
		super(props);
		this.app = App.getInstance();

		this.state = {};
	}

	private handleEditBoardClick = (): void => {
		this.app.editModeStart();
	};

	// Методы рендеринга элементов меню
	private renderItem = (spec: MenuItemSpec): React.ReactNode => {
		const { tooltip, onClick } = spec;
		const classBlock = 'dropdown';

		const label = typeof spec.label === 'string' ? spec.label : spec.label?.(spec);
		return (
			<button
				title={tooltip}
				onClick={(e)=>spec.onClick?.(spec)}
				className={`${classBlock}__item-button`}
			>
				<div className={`${classBlock}__item-button-label`}>
					{label}
				</div>
			</button>
		);
	};

	private renderEditBoardItem = (spec: MenuItemSpec): React.ReactNode => {
		return this.renderItem({ ...spec, onClick: this.handleEditBoardClick });
	};

	private renderManageDataItem = (spec: MenuItemSpec): React.ReactNode => {
		return this.renderItem({
			...spec,
			onClick: (spec)=>{
				// Открытие модального окна управления данными через статический метод
				DataManagementDialog.show();
			},
		});
	};

	// Создание спецификации меню
	private getMenuSpecification(): MenuItemSpec[] {
		return [
			// Опция "Управление данными"
			{
				id: 'manage-data',
				render: this.renderManageDataItem,
				label: 'Управление данными',
				tooltip: 'Экспорт, импорт и очистка данных приложения',
				autoClose: true,
			},
		];
	}

	render() {
		return (
			<div className={this.classBlock}>
				<DropdownMenu
					buttonProps={{
						icon: '⚙️',
						label: 'Еще',
						title: 'Дополнительные настройки',
						className: this.classBlock + '--button',
					}}
					menuItems={this.getMenuSpecification()}
				/>
			</div>
		);
	}
}

export default SettingsMenu;
